<template>
  <div class="table-container">
    <div class="table-responsive table-scrollable" :class="scrollableClass" v-if="items?.length > 0">
      <table class="table table-striped c-table">
        <thead>
        <tr class="sticky-header">
          <th>ردیف</th>
          <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
          <th class="nowrap" v-show="!noOperation">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td class="vw-3">{{ index + 1 }}</td>
          <td v-for="field in fields" :key="field">{{ !!item[field] ? item[field] : '...' }}</td>
          <td class="vw-5" v-show="!noOperation">
            <a
                type="button"
                v-if="openEditModalMethod"
                @click="openEditModalMethod(item, index)"
            >
              <img class="table-edit-img" src="../../assets/img/pen.svg" alt="edit" title="ویرایش">
            </a>
            <a type="button" class="ms-2" @click="openDeleteModal(index)">
              <img class="table-delete-img" src="../../assets/img/delete.svg" alt="delete" title="حذف">
            </a>
          </td>
        </tr>
        </tbody>
        <tfoot v-if="$slots.footer">
          <slot name="footer"></slot>
        </tfoot>
      </table>
    </div>
    <div v-else class="alert alert-info m-3">
      موردی وجود ندارد
    </div>

    <ConfirmModal
        ref="confirmModal"
        v-show="deleteIndex"
        title="حذف"
        message="آیا از حذف مطمئن هستید؟"
        @closed="closeModal"
        @confirmed="confirmRemove"
    />
  </div>
</template>

<script>
import ConfirmModal from "@/components/GeneralComponents/ConfirmModal.vue";

export default {
  components: {ConfirmModal},
  props: {
    headers: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    openEditModalMethod: {
      type: Function,
      default: null
    },
    scrollableClass: {
      type: String,
      default: null
    },
    noOperation: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      deleteIndex: null
    }
  },
  methods: {
    openDeleteModal(index) {
      this.deleteIndex = index;
      this.$refs.confirmModal.openConfirmModal()
    },
    closeModal() {
      this.deleteIndex = null;
    },
    confirmRemove() {
      this.$emit('remove', this.deleteIndex);
      this.deleteIndex = null;
    }
  }
};
</script>
